import React, { Component } from 'react';
import styled from 'styled-components';
import preloader from '../preload';
import header from '../assets/header.png';
import { result } from '../preload';
import Button from '../Button';

const Wrap = styled.div`
  #bg, #overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 1080px;
    height: 1920px;
  }

  #overlay {
    background: url('${preloader.get(header)}') no-repeat 50% 50px;
  }

  text-align: center;

  h1 {
    margin-top: 360px;
    font-size: 200px;
    font-family: Gagalin-Regular;
  }

  p {
    margin-top: 100px;
    margin-bottom: 80px;
    font-size: 60px;
    font-family: Garamond;
  }

  .Tap {
    margin-top: 15px;
  }
`;

let TITLE = ['Oh, ne!', 'Okej!', 'Cool!', 'Bravo!', 'Super!', 'Top!'];
let TEXT = [
  <p>
    Imaš 0 točnih odgovora.
    <br />
    Bez brige, malo su ti se stvari zapetljale.
  </p>,
  <p>
    Imaš 1 točan odgovor.
    <br />
    Trebaš upiti još malo znanja
    <br />o mentalnoj higijeni.
  </p>,
  <p>
    Imaš 2 točna odgovora.
    <br />
    Možeš malo češće očistiti raspored
    <br />
    za mentalnu higijenu.
  </p>,
  <p>
    Imaš 3 točna odgovora.
    <br />
    Tvoja baza znanja o mentalnoj
    <br />
    higijeni je dobro postavljena.
  </p>,
  <p>
    Imaš 4 točna odgovora.
    <br />
    Trebaš još samo malo brusiti
    <br />
    znanje o mentalnoj higijeni.
  </p>,
  <p>
    Imaš 5 točnih odgovora.
    <br />
    Ti sigurno redovito održavaš
    <br />
    mentalnu higijenu!
  </p>,
];

class Screen extends Component {
  render() {
    let score = this.props.score;
    if (score > 5) score = 5;

    let finish = () => {
      window.track('finish');
      this.props.gotoNextScreen();
    };

    let tryAgain = () => {
      window.track('again');
      this.props.gotoFirstScreen();
    };

    return (
      <Wrap>
        <video id="bg" src={preloader.get(result[score])} muted autoPlay loop />
        <div id="overlay">
          <h1>{TITLE[score]}</h1>
          {TEXT[score]}
          <Button className="white" onTap={finish}>
            Završi kviz
          </Button>
          <Button onTap={tryAgain}>Igraj ponovno</Button>
        </div>
      </Wrap>
    );
  }
}

export default Screen;
